module.exports = __webpack_public_path__ + "img/img6.eef200eb.png";